<div class="main-container">
    <dello-notify></dello-notify>
    <router-outlet></router-outlet>
</div>
